import { useCallback, useMemo } from "react";

import { ConfigurationBom } from "@plansoft-configuration-renderer/configuration-api";
import {
  createConfigurationApi,
  useConfigurationMeta,
  useSessionId,
} from "@plansoft-configuration-renderer/framework";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

export const getBomQueryKey = "bomQueryKey";

export function useBom(): UseQueryResult<ConfigurationBom, Error> {
  const { baseUrl } = useConfigurationMeta();
  const sessionId = useSessionId();

  const cfgApi = useMemo(() => {
    return createConfigurationApi({
      basePath: baseUrl,
      apiKey: "",
    });
  }, [baseUrl]);

  const bomFetcher = useCallback(
    () => cfgApi.getBom({ id: sessionId }),
    [cfgApi, sessionId],
  );

  return useQuery({
    queryKey: [getBomQueryKey],
    queryFn: bomFetcher,
  });
}
